<template>
    <div class="slide container">
        <h2>Visualisierung</h2>
        <PvInformation/>
        <DailyGraph class="mt-5"/>
    </div>
</template>

<script>
    import DailyGraph from '../extras/DailyGraph';
    import PvInformation from '../extras/PvInformation';

    export default {
        name: 'VisualizeSlide',
        components: {
            DailyGraph,
            PvInformation,
        },
        props: {},
        methods: {},
    };
</script>

<style scoped>

</style>
